import { createFileRoute } from '@tanstack/react-router';
import { IconUsersGroup } from '@tabler/icons-react';
import { ResourceListPage } from '@/shared/components/ResourceListPage';
import { QuickCreateButton, type FieldDef } from '@/shared/components/QuickCreateButton';
import type { Denormalized } from '@/shared/api/jsonapi/parser';

interface Group extends Denormalized {
  type: 'erp-business-groups';
  code?: string;
  name?: string;
  description?: string;
  function?: string;
  isActive?: boolean;
}

const FIELDS: FieldDef[] = [
  { name: 'code', label: 'Codice', required: true },
  { name: 'name', label: 'Nome', required: true },
  { name: 'description', label: 'Descrizione', kind: 'textarea' },
  { name: 'function', label: 'Funzione', placeholder: 'Es. Sviluppo, HR, Vendite' },
  { name: 'sortOrder', label: 'Ordinamento', kind: 'number', defaultValue: 0 },
  { name: 'isActive', label: 'Attivo', kind: 'boolean', defaultValue: true },
];

export const Route = createFileRoute('/_app/workforce/groups')({ component: GroupsPage });

function GroupsPage() {
  return (
    <ResourceListPage<Group>
      title=""
      type="erp-business-groups"
      columns={[
        { accessorKey: 'code', header: 'Codice', size: 110 },
        { accessorKey: 'name', header: 'Gruppo' },
        { accessorKey: 'function', header: 'Funzione' },
        { accessorKey: 'isActive', header: 'Attivo', size: 90, Cell: ({ cell }) => (cell.getValue<boolean>() ? '✓' : '—') },
      ]}
      searchField="name"
      emptyMessage="Nessun gruppo"
      emptyDescription="Crea il primo gruppo con il bottone «Nuovo gruppo» nella toolbar."
      emptyIcon={IconUsersGroup}
      editFields={FIELDS}
      editTitle="Modifica gruppo"
      enableDelete
      getRowLabel={(r) => r.name ?? r.code ?? r.id}
      toolbarRight={<QuickCreateButton type="erp-business-groups" title="Nuovo gruppo" fields={FIELDS} />}
    />
  );
}
